import { Accordion, AccordionDetails, AccordionSummary, styled } from '@mui/material';

export const StyledAccordion = styled(Accordion)(({ theme }) => ({
  boxShadow: theme.shadows[0],
}));

export const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  boxShadow: theme.shadows[1],
  minHeight: theme.spacing(12.8),
  borderRadius: 'inherit',
  '&.Mui-expanded': {
    minHeight: theme.spacing(12.8),
    backgroundColor: '#F7F5F7',
  },
  '&.Mui-expanded .MuiTypography-root': {
    fontWeight: 'bold',
  },
}));

export const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  marginTop: theme.spacing(6.4),
  marginBottom: theme.spacing(2.1333),
  padding: '0',
}));
